<div class="search-results-container">
  <!-- Panel Header (fixed, same pattern as Search Cases) -->
  <div class="panel-header">
    <h3>Search Results</h3>
  </div>

  <div class="results-scroll-area">
    <app-toast [toast]="toast()" (dismissed)="clearToast()" />

    <!-- Toolbar -->
    <app-data-table [columns]="columns" [data]="searchResults()" maxHeight="350px" [trackBy]="trackByCaseNo"
      [isSelected]="isRowSelected" [filterKeys]="filterKeys" filterPlaceholder="Type to filter..."
      emptyMessage="No cases found. Enter query above and search." [radioMode]="true" [serverSide]="true"
      [totalRecords]="totalRecords()" [page]="currentPage()" (pageOrSizeChange)="onPageOrSizeChange($event)"
      (rowClick)="selectCase($event)">
      <ng-template #rowDetail let-item>
        @let caseDesc = item.caseDesc ?? '';
        @if (caseDesc.trim()) {
        <div class="notes-content">
          <span class="notes-label">Notes</span>
          <div class="notes-body-wrapper">
            @if (expandedCases().has(item.caseNo)) {
            <div class="notes-scroll-container">
              <p class="notes-text full-text">{{ caseDesc }}</p>
            </div>
            @if (caseDesc.length > 150) {
            <button class="read-toggle-btn" (click)="toggleNotes(item.caseNo, $event)" aria-label="Read less notes">
              Read Less
            </button>
            }
            } @else {
            <p class="notes-text">
              {{ caseDesc.length > 150 ? (caseDesc | slice:0:150) + '...' : caseDesc }}
              @if (caseDesc.length > 150) {
              <button class="read-toggle-btn" (click)="toggleNotes(item.caseNo, $event)" aria-label="Read more notes">
                Read More
              </button>
              }
            </p>
            }
          </div>
        </div>
        }
      </ng-template>
    </app-data-table>
  </div>

  <!-- Full Notes Modal (fixed-position overlay, kept outside the scroll area) -->
  @if (activeModalCase(); as caseItem) {
  <div class="modal-backdrop" (click)="closeNotesModal()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="modal-title-wrapper">
          <h4>Case Notes & Description</h4>
          <span class="modal-subtitle">Case #{{caseItem.caseNo}} - {{caseItem.address}}</span>
        </div>
        <button class="modal-close-btn" (click)="closeNotesModal()" aria-label="Close notes modal">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <p class="modal-full-text">{{caseItem.caseDesc}}</p>
      </div>
      <div class="modal-footer">
        <button class="btn-modal-close" (click)="closeNotesModal()" aria-label="Close">Close</button>
      </div>
    </div>
  </div>
  }
</div>